import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Input } from "../../../../../../shared/components/input/Input";
import { Label } from "../../../../../../shared/components/label/Label";

const CreatePeriodForm = ({ onSubmitHandler, trackerGoal }) => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(
        t("objectivesTracker.createPeriodForm.fields.beginDate.required"),
      ),
    endDate: yup
      .date()
      .required(
        t("objectivesTracker.createPeriodForm.fields.endDate.required"),
      ),
  });

  const defaultValues = {
    beginDate: "",
    endDate: "",
  };

  const [ratio, setRatio] = useState(0);
  const [goal, setGoal] = useState(0);

  const onGoalChangeHandler = (e) => {
    const goalToReachValue = +e.target.value;
    const ratioToReachValue = (goalToReachValue / trackerGoal) * 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onRatioChangeHandler = (e) => {
    const ratioToReachValue = +e.target.value;
    const goalToReachValue = (trackerGoal * ratioToReachValue) / 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onSubmit = (formValues) => {
    onSubmitHandler({ ...formValues, goal: goal });
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmit}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t(
              "objectivesTracker.createPeriodForm.fields.beginDate.label",
            )}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("objectivesTracker.createPeriodForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.createPeriodForm.fields.goal.label")}
          </Label>
          <Input type="number" onChange={onGoalChangeHandler} value={goal} />
        </div>
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.createPeriodForm.fields.ratio.label")}
          </Label>
          <Input type="number" onChange={onRatioChangeHandler} value={ratio} />
        </div>
      </div>
    </BaseForm>
  );
};

export default CreatePeriodForm;
